module.exports = __webpack_public_path__ + "static/media/company_logo1.384ce3d4.png";